import httpClient from '@yola/http-client';
import composeExtensionAssetUrl from './compose-extension-asset-url';

const fetchExtensionAsset = (slug, source) => {
  const url = composeExtensionAssetUrl(slug, source);
  return httpClient.get(url);
};

export default fetchExtensionAsset;
